import React, { Component, useRef, useState } from 'react'
import { MainSection } from '../../Components/MainSection'
import Slider from '../../Components/Slider'
import poster from '../../assets/video-still.png'

class HeroZones extends Component {
  render() {
    const { content, openModal } = this.props
    let windowWidth = window.innerWidth

    return (
      <div>
        {content.video && (
          <HeroVideo video={content.video} openModal={openModal} />
        )}
        {content.image && windowWidth >= 600 && (
          <HeroImage
            image={content.image}
            openModal={openModal}
            size={content.size}
          />
        )}
        {content.image && windowWidth < 600 && (
          <HeroImageSmall
            image={content.image}
            openModal={openModal}
            size={content.size}
          />
        )}
        {content.main && <MainSection content={content.main} />}
        {content.slider && (
          <div className={`slideshow ${content.slider.width}`}>
            <Slider
              options={{
                autoPlay: false,
                pauseAutoPlayOnHover: true,
                wrapAround: false,
                contain: true,
                prevNextButtons: false,
                imagesLoaded: true,
                cellAlign: 'left'
              }}
            >
              {content.slider.images.map((image, index) => (
                <div
                  style={{ width: 'auto', height: '400px', margin: '0 0.5em' }}
                  key={index}
                >
                  {windowWidth < 600 && (
                    <img src={content.slider.smallImages[index]} alt="" />
                  )}
                  {windowWidth >= 600 && <img src={image} alt="" />}
                  <p className="caption">{content.slider.captions[index]}</p>
                </div>
              ))}
            </Slider>
          </div>
        )}
      </div>
    )
  }
}

function HeroVideo({ video, openModal }) {
  const vidRef = useRef(null)
  const [isActive, setActive] = useState(false)

  const handlePlayVideo = () => {
    vidRef.current.muted = false
    setActive(!isActive)
    isActive ? vidRef.current.pause() : vidRef.current.play()
  }

  return (
    <div className="zone-outer">
      <div id={'hero-video-container'}>
        <video muted loop playsInline ref={vidRef} poster={poster}>
          <source
            src={video.src}
            type={'video/mp4'}
            width={window.innerWidth * 0.5}
            height={window.innerHeight}
          />
          {video.alt}
        </video>
        <button
          className={isActive ? 'show' : 'hide'}
          id={'playVideo'}
          onClick={() => handlePlayVideo()}
        />
      </div>
    </div>
  )
}

function HeroImage({ image, openModal, size }) {
  return (
    <div className={`zone-outer ${size}`}>
      <div className={`zonewrapper-center zonewrapper zonewrapper-main`}>
        <div className={'zonewrapper-content'}>
          <span className="square tl"></span>
          <span className="square tr"></span>
          <span className="square bl"></span>
          <span className="square br"></span>
          <img src={image.src} alt="" />
        </div>
      </div>
    </div>
  )
}
function HeroImageSmall({ image, openModal, size }) {
  return (
    <div className={`zone-outer ${size}`}>
      <div className={`zonewrapper-center zonewrapper zonewrapper-main`}>
        <div className={'zonewrapper-content'}>
          <span className="square tl"></span>
          <span className="square tr"></span>
          <span className="square bl"></span>
          <span className="square br"></span>
          <img src={image.smallSrc} alt="" />
        </div>
      </div>
    </div>
  )
}
export default HeroZones



// WEBPACK FOOTER //
// ./src/Views/Home/HeroZones.js